import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { LogoutRequestDto } from "../generated/schema";

export function useLogout() {
	const mutation = $api.useMutation("post", "/auth/logout");

	return useMutation({
		mutationFn: async (data: LogoutRequestDto) => {
			return mutation.mutateAsync({
				body: data,
				headers: {
					"x-auth-request": "true",
				},
				credentials: "include",
			});
		},
	});
}
